import api from "./index";
import { ENDPOINTS } from "./endpoints";

export const getSellerProfile = () =>
  api.get(ENDPOINTS.SELLER_PROFILE.PROFILE_GET);

export const updateSellerProfile = (data) =>
  api.put(ENDPOINTS.SELLER_PROFILE.PROFILE_UPDATE, data);